import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 font-medium text-xl mb-3" }, "Manage Phone Numbers", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3" }, "Manage your existing phone numbers or purchase a new one.", -1)
const _hoisted_3 = { class: "surface-card p-4 shadow-2 border-round" }
const _hoisted_4 = { class: "grid formgrid p-fluid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-500 font-medium text-lg mb-3" }, "Purchase A New Number", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "surface-100 mb-3 col-12",
  style: {"height":"2px"}
}, null, -1)
const _hoisted_7 = { class: "field mb-4 col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "font-medium"
}, "Search Available Phone Numbers", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 pt-3 text-600 line-height-3 mr-3" }, "In order to send SMS messages via any of your campaigns, you will need to have a viable phone number. Search here to see what numbers are available.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-500 font-medium text-lg mb-3" }, "Your Existing Phone Numbers", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "surface-100 mb-3 col-12",
  style: {"height":"2px"}
}, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "field mb-4 col-12"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3" }, "You do not have any existing numbers. Purchase a number above.", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "field mb-4 col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"85vh"} }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_AutoComplete, {
                modelValue: _ctx.selectedPhoneNumber,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPhoneNumber) = $event)),
                suggestions: _ctx.availablePhoneNumbers,
                onComplete: _ctx.searchAvailablePhoneNumbers,
                field: "phoneNumber",
                dataKey: "phoneNumber",
                placeholder: "Enter a number or part of it"
              }, null, 8, ["modelValue", "suggestions", "onComplete"]),
              _createVNode(_component_Button, {
                disabled: !_ctx.selectedPhoneNumber?.phoneNumber,
                class: "w-auto mt-3",
                label: "Purchase Number",
                onClick: _ctx.purchaseNumber
              }, null, 8, ["disabled", "onClick"]),
              _hoisted_9
            ]),
            _hoisted_10,
            _hoisted_11,
            (!_ctx.phoneNumbers?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_DataTable, {
                    value: _ctx.phoneNumbers,
                    rowClass: _ctx.phoneNumberRowClass,
                    scrollable: "",
                    scrollHeight: "400px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "phoneNumber",
                        header: "Phone Number"
                      }),
                      _createVNode(_component_Column, {
                        field: "country",
                        header: "Country"
                      }),
                      _createVNode(_component_Column, {
                        field: "isActive",
                        header: "Status"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Tag, {
                            value: slotProps.data.isActive ? 'Active' : 'Inactive',
                            severity: slotProps.data.isActive ? 'success' : 'secondary'
                          }, null, 8, ["value", "severity"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { bodyStyle: "width: 4rem; text-align: center;" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Button, {
                            icon: "pi pi-trash",
                            class: "p-button-rounded p-button-danger",
                            onClick: ($event: any) => (_ctx.confirmDeleteNumber(slotProps.data.phoneNumberId))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "rowClass"])
                ]))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}